import noop from "lodash/fp/noop";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Tag from "./Tag";
import TagsAutosizeInput from "./TagsAutosizeInput";
import TagsInputContainer from "./TagsInputContainer";
import TagsWrapper from "./TagsWrapper";

export default class TagsInput extends Component {
  static propTypes = {
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,

    value: PropTypes.array,

    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    validationState: PropTypes.string,
  };

  static defaultProps = {
    value: [],
    onBlur: () => {},
    validationState: null,
    disabled: false,
    placeholder: null,
    onFocus: noop,
  };

  state = {
    inputValue: "",
  };

  handleChange = item => {
    const { value: selectedItems, onChange } = this.props;

    onChange([...selectedItems, item]);
    this.input.focus();
  };

  handleInputKeyDown = e => {
    const { value, onChange } = this.props;
    const isCommandOrCtrl = e.metaKey || e.ctrlKey;

    if (isCommandOrCtrl) {
      if (e.key === "Backspace") {
        this.setState({
          inputValue: "",
        });

        onChange([], e);
        return;
      }
    }

    if (e.key === "Backspace" && !e.target.value) {
      const nextValue = [...value];
      nextValue.pop();

      onChange(nextValue, e);
    }

    if (["Enter", ",", "Tab"].includes(e.key) || e.keyCode === 32) {
      if (!e.target.value) {
        return;
      }

      this.setState({
        inputValue: "",
      });

      onChange([...value, e.target.value], e);
      e.preventDefault();
    }
  };

  handleRemove = index => {
    const { value, onChange } = this.props;

    onChange(value.filter((tag, maybeIndex) => maybeIndex !== index));
  };

  handleInputChange = e => {
    const inputValue = e.target.value;

    if (inputValue.includes(",")) {
      const { value, onChange } = this.props;

      onChange([
        ...value,
        ...inputValue
          .split(",")
          .map(tag => tag.trim())
          .filter(Boolean),
      ]);

      return;
    }

    this.setState({
      inputValue,
    });
  };

  handleBlur = e => {
    const { onBlur, value } = this.props;

    if (onBlur) {
      onBlur(value, e);
      this.setState({
        inputValue: "",
      });
    }
  };

  handleClear = () => {
    this.props.onChange([]);
    this.input.focus();
  };

  inputRef = inputRef => {
    this.input = inputRef;
  };

  /**
   * @return {ReactElement}
   */
  render() {
    const { placeholder, value, validationState } = this.props;
    const { disabled } = this.props;

    return (
      <TagsInputContainer disabled={disabled} css={inputContainerStyle} validationState={validationState}>
        <TagsWrapper>
          {value.map((tag, index) => (
            <Tag key={tag} onClose={() => this.handleRemove(index)} isActive={true}>
              {tag}
            </Tag>
          ))}
          <TagsAutosizeInput
            placeholder={placeholder}
            value={this.state.inputValue}
            disabled={disabled}
            onChange={this.handleInputChange}
            onKeyDown={this.handleInputKeyDown}
            onFocus={this.props.onFocus}
            onBlur={this.handleBlur}
          />
        </TagsWrapper>
      </TagsInputContainer>
    );
  }
}

const inputContainerStyle = {
  paddingRight: 0,
};
